import { useEffect, useRef, useState } from "react";
import { Background } from "react-flow-renderer";
import Controls from "../../components/general/Controls";
import { Wrapper, FlowBoard, Map, Container } from "./styles";
import UndoRedo from "../../components/general/UndoRedo";
import { nodeTypes, edgeTypes, getNodeType } from "./utils";
import Sidebar from "../../components/general/Sidebar";
import SaveButton from "./SaveButton";
import DropSelectVersion from "../../components/general/DropSelectVersion";
import Critical from "../../components/general/CriticalButton";
import User from "../../components/general/UserAvatar";
import HelpButton from "../../components/general/HelpButton";
import { useDispatch, useSelector } from "react-redux";
import { selectUndoFlow } from "../../state/undoFlow/selectors";
import {
  clearUndoFlow,
  updateAddEdge,
  updateDrop,
  updateNodeSelectDrag,
  updateNodeSingleDrag,
  updateRemove,
  updateFlow,
} from "../../state/undoFlow/actions";
import Loading from "../../components/LoadingTemplate/index";
import CustomConnectionLine from "../../components/CustomConnectionLine";
import useNodesSelected from "../../hooks/useNodesSelected";
import useChangePosition from "../../hooks/useChangePosition";
import { ActionCreators } from "redux-undo";
import { useCutCopyPaste } from "../../hooks/useCutCopyPaste";
import { useHotkeys } from "react-hotkeys-hook";
import { clearPane, updateCurrent } from "../../state/flows/actions";
import { fetchSingleFlow } from "../../state/flows/reducers";
import { useHistory, useLocation } from "react-router-dom";
import {
  getPaneStatus,
  getPaneFlow,
  getDefaultPaneFlow,
  getCurrent,
} from "../../state/flows/selectors";

import useCriticalPath from "../../hooks/useCriticalPath";
import { useZoomPanHelper } from "react-flow-renderer";
import { useVerifyToken } from "../../hooks/useVerifyToken";
import ConditionalPopper from "./ConditionalPopper";
import { notificationNavigateDashboard } from "../../components/Notifications/BellComponent/utils";
import { BellComponent } from "../../components/Notifications/BellComponent";

const FlowPane = (props) => {
  //router Location
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  //token de usuário
  const user = useSelector((state) => state.auth.user);

  const flow = useSelector((state) => getPaneFlow(state));
  const defaultFlow = useSelector((state) => getDefaultPaneFlow(state));
  const status = useSelector((state) => getPaneStatus(state));
  const current = useSelector((state) => getCurrent(state));

  const state = location.pathname.split("/")[2];


  const redirectionNotificationFunctions = {
    "task_mention": notificationNavigateDashboard
  }



  const isLoading =
    status !== "succeeded" && state === "edition" ? true : false;

  //React router 5.2.0
  const history = useHistory();

  const [title, setTitle] = useState(flow?.title ? flow.title : "");

  //Pooper Condicional
  const [selectedConditional, setSelectedConditional] = useState({
    isOpen: false, // Pooper Opener
    current: {}, // Information of current conditional
    target: null, // Target / location
  });

  const [currentEdgesData, setCurrentEdgesData] = useState([]);

  //Caminho critico
  const [critical, setCritical] = useState(false);
  const [criticalStats, setCriticalStats] = useState(null);

  //ReactFlow
  const [reactFlowapi, setReactFlowapi] = useState(null);
  const [count, setCount] = useState(1);
  const [selected, setSelected] = useState(null);
  const undoFlow = useSelector(selectUndoFlow);

  //Nodes Selected Hook
  const [isSelectable, setIsSelectable] = useState(false);
  const [selectableFlow, setSelectableFlow] = useState(null);

  //Arrow Keys hook
  const [arrow, setArrow] = useState(false);
  const [coordinates, setCoordinates] = useState(false);

  //Controlador de Versão

  //Drag Lock
  const [lock, setUnlock] = useState(state === "edition" ? false : false);

  //Ref da tela
  const reactFlowWrapper = useRef(null);

  //Todas os Fluxos contidos no Id

  const dispatch = useDispatch();

  const { fitView } = useZoomPanHelper();

  const fetchingData = async () => {
    if (isLoading && user) {
      dispatch(
        fetchSingleFlow({
          tenantId: !user.tenantId ? user?._id : user.tenantId,
          _id: params.get("flowId"),
        })
      ).catch((err) => {
        console.error(err.message);
        history.push("/");
      });
    }
  };

  const loadFlow = (flow) => {
    const isLoadingElements = flow && status === "succeeded";

    if (isLoadingElements) {
      const elements = flow.elements;

      dispatch(updateCurrent({ flow }));
      dispatch(updateFlow(elements));
      dispatch(ActionCreators.clearHistory());
    }
  };

  const loadTitle = (title) => {
    const isCurrent = status === "succeeded";
    if (isCurrent) setTitle(title);
  };

  const onDoubleClick = (e, node) => {
    if (node?.type === "conditional") {
      setSelectedConditional({
        isOpen: true, // Pooper Opener
        current: node, // Information of current conditional
        target: e.target, // Target / location
      });
    }
  };

  const handleCloseConditional = () => {
    setSelectedConditional({
      isOpen: false,
      current: {},
      target: null,
    });
  };
  useEffect(
    () => () => {
      //unmount
      dispatch(clearUndoFlow());
      dispatch(ActionCreators.clearHistory());
      dispatch(clearPane());
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  useEffect(() => {
    loadTitle(current.title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current]);

  useEffect(() => {
    loadFlow(defaultFlow);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  useEffect(() => {
    fetchingData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, user]);

  useVerifyToken();

  //mount
  useEffect(() => {
    if (state !== "creation" && state !== "edition") {
      history.push("/404");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  //Somente utilizado em edit e version(fetching)

  const onLoad = (_reactFlowapi) => {
    setReactFlowapi(_reactFlowapi);
  };

  useEffect(() => {
    fitView({ padding: 0.2 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reactFlowapi]);

  const onConnect = (params) => {
    if (undoFlow.find((e) => e.id === params.source).type === "conditional") {
      dispatch(
        updateAddEdge({
          params: {
            ...params,
            type: "customEdge",
            data: { text: `Etiqueta ${count}`, status: "pending" },
          },
        })
      );
      setCount((e) => e + 1);
    } else {
      dispatch(
        updateAddEdge({
          params: {
            ...params,
            type: "customEdgeWithoutLabel",
            data: { status: "pending" },
          },
        })
      );
    }
  };

  const onElementsRemove = (elementsToRemove) => {
    dispatch(updateRemove(elementsToRemove));
  };

  const onDragOver = (event) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = "move";
  };

  const onDrop = (event) => {
    event.preventDefault();
    const reactFlowBounds = reactFlowWrapper.current.getBoundingClientRect();
    const type = event.dataTransfer.getData("application/reactflow");

    const position = reactFlowapi.project({
      x: event.clientX - reactFlowBounds.left,
      y: event.clientY - reactFlowBounds.top,
    });
    const newNode = getNodeType(position, type);

    if (newNode) {
      dispatch(updateDrop({ newNode }));
    }
  };

  //  Movendo vários itens selecionados
  const onNodeSelectDrag = (e, nodes) =>
    dispatch(
      updateNodeSelectDrag({ nodes: nodes, API: reactFlowapi?.getElements() })
    );
  //  Movendo um item selecionado
  const onNodeSingleDrag = (e, node) =>
    dispatch(
      updateNodeSingleDrag({ node: node, API: reactFlowapi?.getElements() })
    );
  const handleSelect = (selected) => setSelected(selected);

  //undo-redo
  const undoOperation = () => dispatch(ActionCreators.undo());
  const redoOperation = () => dispatch(ActionCreators.redo());

  //Selectable Flow
  const selectFlow = (flow) => setSelectableFlow(flow);
  const isSelectableTrue = () => setIsSelectable(true);
  const isSelectableFalse = () => setIsSelectable(false);

  //Minimap

  const nodeColor = (node) => {
    if (node.type === "customMark") {
      return node.data.hexColor;
    } else {
      return "#fff";
    }
  };

  //Hooks
  useHotkeys("ctrl+z", undoOperation, { keydown: true }, [undoFlow]);
  useHotkeys("ctrl+y", redoOperation, { keydown: true }, [undoFlow]);

  // useKey(['ArrowLeft'], () => ArrowLeftEnter(setCoordinates, setArrow));
  // useKey(['ArrowRight'], () => ArrowRightEntered(setCoordinates, setArrow));
  // useKey(['ArrowUp'], () => ArrowUpEntered(setCoordinates, setArrow));
  // useKey(['ArrowDown'], () => ArrowDownEntered(setCoordinates, setArrow));
  useCutCopyPaste(undoFlow, selected, selectFlow, isSelectableTrue);
  useNodesSelected(isSelectableFalse, selectableFlow, isSelectable);
  useChangePosition(setArrow, coordinates, arrow);
  useCriticalPath(critical, undoFlow, setCriticalStats);

  return (
    <>
      {!isLoading ? (
        <Wrapper>
          <FlowBoard
            minZoom={0}
            ref={reactFlowWrapper}
            elements={undoFlow}
            nodeTypes={nodeTypes}
            edgeTypes={edgeTypes}
            nodesDraggable={!lock && !critical}
            nodesConnectable={!lock && !critical}
            elementsSelectable={!lock && !critical}
            onLoad={onLoad}
            onConnect={onConnect}
            connectionLineComponent={CustomConnectionLine}
            onElementsRemove={onElementsRemove}
            onDragOver={onDragOver}
            onDrop={onDrop}
            onNodeDragStop={onNodeSingleDrag}
            onSelectionDragStop={onNodeSelectDrag}
            deleteKeyCode="Delete"
            multiSelectionKeyCode="Control"
            onSelectionChange={(select) => handleSelect(select)}
            onNodeDoubleClick={onDoubleClick}
          >
            <Sidebar />
            <Controls lock={lock} setUnlock={setUnlock} />
            <UndoRedo undo={undoOperation} redo={redoOperation} />
            <Background />
            <Map nodeColor={nodeColor} />
            <DropSelectVersion
              state={state}
              selector={state === "edition" ? true : false}
              title={title}
              setTitle={(data) => setTitle(data)}
              setCritical={setCritical}
              loadflow={loadFlow}
            />
            <Container>
              <SaveButton
                elements={undoFlow}
                loadflow={loadFlow}
                title={title}
                state={state}
              />
              <Critical
                elements={undoFlow}
                critical={critical}
                setCritical={() => setCritical((prev) => !prev)}
                selectFlow={selectFlow}
                setIsSelectable={setIsSelectable}
                value={criticalStats ? criticalStats : null}
              />
              <HelpButton />
              <BellComponent redirectionFunctions={redirectionNotificationFunctions}/>
              <User user={user} />
            </Container>
          </FlowBoard>
        </Wrapper>
      ) : (
        <Loading />
      )}
      {selectedConditional.isOpen ? (
        <ConditionalPopper
          isOpen={selectedConditional.isOpen}
          onClose={handleCloseConditional}
          anchorRef={selectedConditional.target}
          inicialText={selectedConditional.current.data.label}
          node={selectedConditional.current}
          startingEdges={currentEdgesData}
        />
      ) : null}
    </>
  );
};

export default FlowPane;
